import { CommonModule, DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ComponentRef,
  Inject,
  OnDestroy,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { PaginationService } from 'ngx-pagination';
import { Subscription } from 'rxjs';
import { Modal } from 'src/app/core/helpers/modal.helper';
import { ModalDataI, ModalService } from 'src/app/core/services/modal.service';
import { UiModule } from 'src/app/ui/ui.module';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, UiModule],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  providers: [PaginationService],
})
export class ModalComponent implements AfterViewInit, OnDestroy {
  @ViewChild('modalContainer', { read: ViewContainerRef })
  container!: ViewContainerRef;

  componentRef: ComponentRef<any> | null = null;
  modalClass = '';
  title = '';
  isOpen = false;

  private sub!: Subscription;
  private pendingConfig: ModalDataI | null = null;

  constructor(
    private modalService: ModalService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngAfterViewInit() {
    this.sub = this.modalService.modal$.subscribe((config: ModalDataI) => {
      this.pendingConfig = config;

      this.isOpen = true;
      this.renderer.addClass(this.document.body, 'no-scroll');
      // Wait for view to render before creating the component
      setTimeout(() => {
        this.injectComponent();
      });
    });

    // 🔔 Listen to close signal from service
    this.modalService.closeModal$.subscribe(() => {
      this.onCleanUp();
    });
  }

  injectComponent() {
    if (!this.container || !this.pendingConfig) return;

    this.container.clear();

    const config = this.pendingConfig;

    const compRef = this.container.createComponent(config.component);

    if (config.componentProps) {
      Object.entries(config.componentProps).forEach(([key, value]) => {
        compRef.setInput(key, value);
      });
    }

    this.componentRef = compRef;
    this.modalClass = config.modalClass || '';

    this.title = config.title || '';
  }

  onClose() {
    Modal.dismiss();
  }

  // trigger internal cleanup
  onCleanUp() {
    this.isOpen = false;
    this.componentRef?.destroy();
    this.componentRef = null;
    this.renderer.removeClass(this.document.body, 'no-scroll');
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
